(function () {
  function getConsentTimestamp() {
    return new Date().toLocaleString('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  async function saveSubscriptionConsent() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Subscription consent': 'Accepted',
          'Subscription consent timestamp': getConsentTimestamp(),
          'Subscription consent terms': 'Customer agreed to subscription terms and conditions before checkout.'
        }
      })
    });
  }

  function initSubscriptionConsent(scope) {
    const blocks = scope.querySelectorAll('[data-subscription-consent]');

    blocks.forEach(function (block) {
      const checkbox = block.querySelector('[data-subscription-consent-checkbox]');
      const error = block.parentElement.querySelector('[data-subscription-consent-error]');

      const buttons = document.querySelectorAll(
        '[name="checkout"], [name="goto_pp"], [name="goto_gc"], .cart-drawer-checkout-btn'
      );

      if (!checkbox || !buttons.length) return;

      function updateButtonState() {
        buttons.forEach(function (button) {
          button.setAttribute('aria-disabled', checkbox.checked ? 'false' : 'true');
          button.classList.toggle('is-disabled', !checkbox.checked);
        });

        if (checkbox.checked && error) {
          error.hidden = true;
        }
      }

      updateButtonState();

      if (checkbox.dataset.subscriptionConsentBound !== 'true') {
        checkbox.dataset.subscriptionConsentBound = 'true';
        checkbox.addEventListener('change', updateButtonState);
      }

      buttons.forEach(function (button) {
        if (button.dataset.subscriptionConsentBound === 'true') return;

        button.dataset.subscriptionConsentBound = 'true';

        button.addEventListener('click', async function (event) {
          if (!checkbox.checked) {
            event.preventDefault();
            event.stopPropagation();

            if (error) error.hidden = false;

            checkbox.focus();
            return;
          }

          event.preventDefault();

          try {
            await saveSubscriptionConsent();
          } catch (err) {
            console.error('Consent save failed:', err);
          }

          const form = button.closest('form');

          if (form) {
            form.submit();
          } else {
            window.location.href = '/checkout';
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSubscriptionConsent(document);
  });

  document.addEventListener('cart:updated', function () {
    initSubscriptionConsent(document);
  });

  const observer = new MutationObserver(function () {
    initSubscriptionConsent(document);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();